// The field names that will be accessible from the AppContext
enum FIELDS {
  QUOTE_ID = 'quoteId',
  POSTCODE = 'postCode'
}

export default FIELDS;
